import React from 'react';

interface SeasonWeekTooltipProps {
  seriesIndex: number;
  dataPointIndex: number;
  w: any;
  selectedCurrency: string;
  priceView?: 'kg' | 'box';
}

const SeasonWeekTooltip: React.FC<SeasonWeekTooltipProps> = ({
  seriesIndex,
  dataPointIndex,
  w,
  selectedCurrency,
  priceView = 'kg',
}) => {
  // Obtenemos el punto actual
  const currentSeries = w.globals.initialSeries[seriesIndex];
  const currentPoint = currentSeries.data[dataPointIndex];

  if (!currentPoint) return '';

  // El x ahora es 'W51', 'W2', etc - no necesitamos formatear
  const weekLabel = currentPoint.x;

  let content = `<div class="apexcharts-tooltip-title">Semana ${weekLabel}</div>`;

  // Obtener datos de todas las series para esta semana
  const allSeriesData = w.globals.initialSeries
    .map((series: any) => {
      const point = series.data.find((p: any) => p.x === currentPoint.x);
      return point
        ? {
            name: series.name,
            value: point.y,
            color: series.color,
          }
        : null;
    })
    .filter((item: any) => item !== null)
    .sort((a: any, b: any) => (b.value || 0) - (a.value || 0));

  allSeriesData.forEach(({ name, value, color }: any, index: number) => {
    content += `
      <div class="apexcharts-tooltip-series-group" style="order: ${index}; display: flex !important;">
        <span class="apexcharts-tooltip-marker" style="background-color: ${color};"></span>
        <div class="apexcharts-tooltip-text">
          <div class="apexcharts-tooltip-y-group">
            <span class="apexcharts-tooltip-text-y-label">${name}: </span>
            <span class="apexcharts-tooltip-text-y-value">
              ${
                typeof value === 'number' ? value.toFixed(2) : 'N/A'
              } ${selectedCurrency}/${priceView === 'kg' ? 'Kg' : '5kg box'}
            </span>
          </div>
        </div>
      </div>
    `;
  });

  return content;
};

export default SeasonWeekTooltip;
